/*
 * Merch-Fieber: einheitliche Cloudlift-Originaldateien für Produktdesigner.
 * Theme "Live Brücke" – Original-Files unverändert hochladen; Druckdateien
 * und ZIPs werden weder neu gerendert noch entfernt.
 */
(() => {
  'use strict';
  const VERSION = 'MF-Cloudlift-Originale-20261023-v1';
  if (window.MFCloudliftOriginalBridge?.version === VERSION) return;
  const pending = new Set();
  const cache = new WeakMap();
  let uploader = null;
  const isOriginalProperty = key => {
    if (!/^properties\[[^\]]+\]$/.test(key)) return false;
    if (/(druckdatei|druck-png|druckdateien|vorschau|preview|screenshot|screencap|zip|designdaten|design-daten|design-json|uploadkopie|originalspeicher|originalzahl)/i.test(key)) return false;
    return /(original|kundenfoto|kundenmotiv|kundendatei|datei.upload|fotoupload|foto|bild|motiv|upload)/i.test(key);
  };
  const isDesigner = fd =>
    fd.has('properties[_MF Designer]') ||
    /designer|personalisier|selbst.gestalt/i.test(String(fd.get('properties[Personalisierung]') || ''));
  const getUploadForm = () => document.getElementById('mf-cloudlift-universal-originals-form');
  const mergeUploadProperties = fd => {
    const form = getUploadForm();
    if (!form) return;
    for (const [key, value] of new FormData(form).entries()) {
      if (typeof value === 'string' && /^properties\[[^\]]+\]$/.test(key) && value && !fd.has(key)) {
        fd.append(key, value);
      }
    }
  };
  window.addEventListener('upload:ready', event => {
    if (typeof event?.detail?.uploadFile !== 'function') return;
    uploader = event.detail;
    for (const resolve of pending) resolve();
    pending.clear();
  });
  async function readyUploader() {
    if (uploader) return uploader;
    await new Promise(resolve => {
      const timer = window.setTimeout(() => { pending.delete(finish); resolve(); }, 7500);
      function finish() { window.clearTimeout(timer); pending.delete(finish); resolve(); }
      pending.add(finish);
    });
    if (!uploader) {
      throw new Error('Cloudlift ist für dieses Produkt noch nicht eingerichtet. Das Originalfoto wurde nicht übertragen. Bitte Upload-Lift für dieses Produkt aktivieren und erneut versuchen.');
    }
    return uploader;
  }
  function remoteUrl(remote) {
    const url = String(remote?.url || '');
    try {
      if (new URL(url).protocol === 'https:') return url;
    } catch (_) {}
    throw new Error('Cloudlift hat keinen gültigen Link zur Originaldatei geliefert.');
  }
  async function uploadExactFile(file, field) {
    if (cache.has(file)) return cache.get(file);
    // File wird direkt hochgeladen, ohne Canvas, Größenänderung oder Komprimierung.
    const url = remoteUrl(await field.uploadFile(file));
    cache.set(file, url);
    return url;
  }
  async function prepare(formData) {
    if (!(formData instanceof FormData) || !isDesigner(formData)) return;
    const originals = [];
    for (const [key, value] of formData.entries()) {
      if (value instanceof File && value.size > 0 && isOriginalProperty(key)) {
        originals.push({key, file:value});
      }
    }
    // Der Fan-Hoodie hat bereits seine eigene Cloudlift- und ZIP-Routine.
    // Vorhandene vollständige Cloudlift-Links werden niemals erneut hochgeladen.
    const alreadyStored = [...formData.entries()].some(([key, value]) =>
      /^properties\[_MF ORIGINAL(?: |\])/i.test(key) &&
      typeof value === 'string' && /^https:\/\//i.test(value)
    );
    if (!originals.length || (alreadyStored && formData.has('properties[_MF Originalspeicher]'))) {
      mergeUploadProperties(formData);
      return;
    }
    const field = await readyUploader();
    // Erst wenn alle Originale erfolgreich gespeichert wurden, die FormData ändern.
    const results = [];
    for (const item of originals) {
      results.push({ ...item, url: await uploadExactFile(item.file, field) });
    }
    const byKey = new Map();
    for (const item of results) {
      if (!byKey.has(item.key)) byKey.set(item.key, []);
      byKey.get(item.key).push(item);
    }
    let number = 0;
    for (const [key, items] of byKey) {
      formData.delete(key);
      for (const item of items) {
        number += 1;
        // Den gewohnten Bestelleigenschaft-Namen beibehalten.
        const name = items.length === 1 ? key :
          'properties[_MF ORIGINALDATEI ' + number + ']';
        formData.append(name, item.url);
        formData.append('properties[_MF ORIGINALNAME ' + number + ']', item.file.name);
      }
    }
    formData.set('properties[_MF Originalspeicher]', 'Cloudlift Originaldateien unverändert (' + results.length + ')');
    formData.set('properties[_MF Originalzahl]', String(results.length));
    mergeUploadProperties(formData);
  }
  const nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function mfCloudliftDesignerFetch(input, init) {
      const url = typeof input === 'string' ? input : String(input?.url || '');
      const body = init?.body;
      if (!/\/cart\/add(?:\.js)?(?:\?|$)/i.test(url) ||
          !(body instanceof FormData) || !isDesigner(body)) {
        return nativeFetch.apply(this, arguments);
      }
      const thisArg = this, args = arguments;
      return prepare(body).then(() => nativeFetch.apply(thisArg, args));
    };
  }
  window.MFCloudliftOriginalBridge = {
    version: VERSION,
    prepare,
    uploadOriginal: async (file) => {
      if (!(file instanceof File) || !file.size) throw new Error('Datei ist leer oder ungültig.');
      const field = await readyUploader();
      return uploadExactFile(file, field);
    },
    status: () => ({
      version: VERSION,
      productHasWidget: Boolean(document.querySelector('[data-upload-lift]')),
      uploaderReady: Boolean(uploader)
    })
  };
})();